module.exports = ".mdi-plus-circle-o{\n    font-size: 48px;\n    color: #4285f4;\n}"